import { css } from 'linaria';
import { StylesMap } from 'types/utils';
import { DiscountPlateSize } from './discount-price-types';

export const discountPriceWrapper = css`
  display: flex;
  column-gap: 8px;
  align-items: center;
`;

export const discountPlate = css`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
`;

export const discountPlateSizeMap: StylesMap<DiscountPlateSize> = {
  s: css`
    width: 33px;
    height: 16px;
  `,
  l: css`
    width: 47px;
    height: 24px;
  `,
};

export const discountPlateImage = css`
  position: absolute;
  z-index: -1;
`;

export const discountPlateTextSizeMap: StylesMap<DiscountPlateSize> = {
  s: css`
    && {
      font-weight: 700;
      font-size: 9px;
      line-height: 14px;
    }
  `,
  l: css`
    && {
      font-weight: 700;
      font-size: 12px;
      line-height: 16px;
    }
  `,
};

export const discountPrice = css`
  font-weight: 600;
  text-decoration: line-through;
  text-decoration-color: #CE0019;
`;
